
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Grid, Button, Card, CardContent, CardHeader, Divider, Typography, TextField, List, ListItem, ListItemText, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow } from "@mui/material";

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import moment from 'moment';
import "moment/locale/es-mx";

import { usePages } from '../../../hooks/usePages';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../../styles/TableStyle';

import { Layout } from "../../../components/Layout"

import { ObtenerAutoridadesMaterias } from '../../../connections/catalogos/AutoridadConnection';
import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';
import { ObtenerTipoJuicio } from '../../../connections/catalogos/TipoJuicioConnection';
import { ObtenerEtapa } from '../../../connections/catalogos/EtapaConnection';
import { ObtenerSubEtapa } from '../../../connections/catalogos/SubEtapaConnection';
import { ObtenerAutoridadExhortoRecibido } from '../../../connections/catalogos/AutoridadExhortoRecibidoConnection';
import { ObtenerClaseExhorto } from '../../../connections/catalogos/ClaseExhortoConnection';
import { ObtenerObjetoExhorto } from '../../../connections/catalogos/ObjetoExhortoConnection';
import { BuscarExhortoRecibidoAnterior, GuardarExhortoRecibidoAnterior } from '../../../connections/recepcion/ExhortoRecibidoConnection';

import { AutoridadProps } from '../../../interfaces/catalogos/AutoridadInterface';
import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { TipoJuicioProps } from '../../../interfaces/catalogos/TipoJuicioInterface';
import { EtapaProps } from '../../../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../../../interfaces/catalogos/SubEtapaInterface';
import { ClaseExhortoProps } from '../../../interfaces/catalogos/ClaseExhortoInterface';
import { AutoridadExhortoRecibidoProps } from '../../../interfaces/catalogos/AutoridadExhortoRecibidoInterface';
import { ObjetoExhortoProps } from '../../../interfaces/catalogos/ObjetoExhortoInterface';
import { defaultExhortoRecibidoAnteriorResponse, ExhortoRecibidoAnteriorParteProps, ExhortoRecibidoAnteriorProps, GuardarExhortoRecibidoAnteriorParams } from '../../../interfaces/recepcion/ExhortoRecibidoInterface';

export const ImportarExhortoPage = () => {

    const dispatch = useDispatch();

    const [exhortoEncontrado, setExhortoEncontrado] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [numeroExhorto, setNumeroExhorto] = useState( '' );

    const [autoridad, setAutoridad] = useState(0);
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );
 
    const [tipoJuicio, setTipoJuicio] = useState(0);
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );

    const [etapa, setEtapa] = useState(0);
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );

    const [subEtapa, setSubEtapa] = useState(0);
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );

    const [autoridadExhortoRecibido, setAutoridadExhortoRecibido] = useState(0);
    const [autoridadExhortoRecibidoArray, setAutoridadExhortoRecibidoArray] = useState<AutoridadExhortoRecibidoProps[]>( [] );

    const [claseExhorto, setClaseExhorto] = useState(0);
    const [claseExhortoArray, setClaseExhortoArray] = useState<ClaseExhortoProps[]>( [] );

    const [objetoExhorto, setObjetoExhorto] = useState(0);
    const [objetoExhortoArray, setObjetoExhortoArray] = useState<ObjetoExhortoProps[]>( [] );

    const [exhortoRecibido, setExhortoRecibido] = useState<ExhortoRecibidoAnteriorProps>( defaultExhortoRecibidoAnteriorResponse );
    const [partes, setPartes] = useState<ExhortoRecibidoAnteriorParteProps[]>( [] );

    const [fechaDevolucion, setFechaDevolucion] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(5);

    const handleBuscar = async () => {

        setLoading( true );

        await BuscarExhortoRecibidoAnterior({ numeroExhorto, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;
            
            if( success ) {

                setTimeout(() => {
        
                    setExhortoEncontrado( true );
                    setNumeroExhorto( '' );
                    setMateria( 0 );
                    setAutoridad( 0 );

                    setExhortoRecibido( resp );
                    setPartes( resp.partes ?? [] );
                    setLoading( false );
                    
                    dispatch( openSnackbar({ message, variant: 'success' }) )
                    
                }, 700);       
            }
            else {
                
                setTimeout(() => {

                    handleClear();                    
                    setLoading( false );
                    dispatch( openSnackbar({ message, variant: 'error' }) )

                }, 700); 
            }

        });  

    }

    const handleClear = () => {

        setExhortoEncontrado( false );
        setNumeroExhorto( '' );
        setMateria( 0 );
        setAutoridad( 0 );
        setTipoJuicio( 0 );

        setEtapa( 0 );
        setSubEtapa( 0 );
        setSubEtapaArray( [] );
        setAutoridadExhortoRecibido( 0 );
        setObjetoExhorto( 0 );
        setClaseExhorto( 0 );

        setFechaDevolucion( moment( new Date() ).format( 'YYYY-MM-DD' ) );
        setExhortoRecibido( defaultExhortoRecibidoAnteriorResponse );
        setPartes( [] );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        const params: GuardarExhortoRecibidoAnteriorParams = {
            idTipoJuicio: tipoJuicio,
            idEtapa: etapa,
            idSubEtapa: subEtapa,
            idAutoridadExhortoRecibido: autoridadExhortoRecibido,
            idClaseExhorto: claseExhorto,
            idObjetoExhorto: objetoExhorto,
            fechaDevolucion,
            idAutoridad: exhortoRecibido.idAutoridad ?? 0,
            numeroExhorto: exhortoRecibido.numeroExhorto ?? '',
            numeroExpedienteOrigen: exhortoRecibido.numeroExpedienteOrigen ?? '',
            numeroFolio: exhortoRecibido.numeroFolio ?? '',
            fechaPresentacion: exhortoRecibido.fechaPresentacion,
            fechaRadicacion: exhortoRecibido.fechaRadicacion,
            partes: exhortoRecibido.partes ?? 0,
        };

        await GuardarExhortoRecibidoAnterior( params ).then( resp => {

            const { success, message } = resp;
            
            if( success ) {

                setTimeout(() => {
        
                    setExhortoRecibido({
                        ...exhortoRecibido,
                        encontrado: true,
                    });

                    handleClear();
                    setLoadingGuardar( false );
                    
                    dispatch( openSnackbar({ message, variant: 'success' }) )
                    
                }, 700);       
            }
            else {
                
                setTimeout(() => {
                    
                    handleClear();
                    setLoadingGuardar( false );
                    
                    dispatch( openSnackbar({ message, variant: 'error' }) )

                }, 700); 
            }

        });  

    }

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerMateria().then( resp => {              
                setMateriaArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {              
                setAutoridadArray( resp );                 
            });

        }

        if( materia !== 0 ){
            Obtener();
        }

    }, [ materia ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerTipoJuicio().then( resp => {              
                setTipoJuicioArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerEtapa().then( resp => {              
                setEtapaArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            setSubEtapa( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapa ).then( resp => {              
                setSubEtapaArray( resp );                 
            });

        }

        Obtener();

    }, [ etapa ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerAutoridadExhortoRecibido().then( resp => {              
                setAutoridadExhortoRecibidoArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerClaseExhorto().then( resp => {              
                setClaseExhortoArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerObjetoExhorto().then( resp => {              
                setObjetoExhortoArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    return (
        <Layout breadcrumbs={[ { text: 'Tribunal' }, { text: 'Importar' }, { text: 'Importar exhorto' } ]} backgroundPaper={false}>
            
            <Grid container spacing={3} >  
                                        
                <Grid size={{ md: 4, xs: 12 }}>

                    <Grid container spacing={3}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <Card>

                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }/>

                                <Divider />

                                <CardContent sx={{ p: 3 }}> 

                                    <Grid container spacing={3} mt={1}>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Número de Exhorto"
                                                variant="outlined"
                                                placeholder={ `1/${ new Date().getFullYear() }` }
                                                value={ numeroExhorto }
                                                onChange={ (e) => setNumeroExhorto( e.target.value ) }
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}       
                                            /> 

                                        </Grid>
                                        
                                        <Grid size={{ xs: 12, md: 12 }}>
                                        
                                            <FormControl required fullWidth>
                                                
                                                <InputLabel>Materia</InputLabel>
                                            
                                                <Select                                                                          
                                                    label="Materia"
                                                    value={ materia }
                                                    onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                                    {
                                                        materiaArray
                                                        .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                                        .map( ( e ) => (
                                                            <MenuItem key={ e.idMateria } value={ e.idMateria }>{ e.descripcion }</MenuItem>                                                        
                                                        ))
                                                    }                     
                                                    
                                                </Select>
                
                                            </FormControl>
                
                                        </Grid>   

                                        <Grid size={{ xs: 12, md: 12 }}>
                                        
                                            <FormControl required fullWidth>
                                                
                                                <InputLabel>Autoridad</InputLabel>
                                            
                                                <Select                                                                          
                                                    label="Autoridad"
                                                    value={ autoridad }
                                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                                    disabled={ materia === 0 }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                                    {
                                                        autoridadArray
                                                        .filter( (e) => e.idAutoridad !== 6 )
                                                        .map( ( e ) => (
                                                            <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>                                                        
                                                        ))
                                                    }                     
                                                    
                                                </Select>
                
                                            </FormControl>
                
                                        </Grid>   

                                        <Grid size={{ md: 12, xs: 12 }} textAlign={'end'}>

                                            <Button 
                                                fullWidth
                                                color={ 'primary' }  
                                                variant={'contained' }    
                                                onClick={ handleBuscar }                      
                                                loading={ loading }
                                                disabled={ numeroExhorto === '' || autoridad === 0 || loading }
                                            > 
                                                Buscar
                                            </Button> 

                                        </Grid>

                                    </Grid>    

                                </CardContent>    

                            </Card>

                        </Grid>          

                    </Grid>

                </Grid> 

                <Grid size={{ md: 8, xs: 12 }}>
                
                    <Card>

                        <CardHeader 
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }} 
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del exhorto </Typography> }                        
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}> 

                            <Grid container spacing={1}>                             
                            
                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de folio: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroFolio } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>    
                                   
                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de Exhorto: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>      

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>Expediente de origen: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen }</Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>   

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de radicación: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.fechaRadicacion ? moment( exhortoRecibido.fechaRadicacion ).format( 'DD-MM-YYYY' ) : '' } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>    

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Juez(a): </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.juez } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid> 

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Juzgado de origen: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.juzgado }</Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>   

                                {
                                    exhortoRecibido.tipoJuicio
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <List disablePadding>
                                
                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography> }
                                                    />

                                                </ListItem>

                                            </List>
                                        
                                        </Grid> 
                                }

                                {
                                    exhortoRecibido.etapa
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <List disablePadding>
                                
                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Etapa: </Typography> }
                                                        secondary={ 
                                                            exhortoRecibido.subEtapa
                                                            ?
                                                                <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.etapa } ({ exhortoRecibido.subEtapa }) </Typography> 
                                                            :
                                                                <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.etapa } </Typography> 
                                                        }
                                                    />

                                                </ListItem>

                                            </List>
                                        
                                        </Grid> 
                                }  

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Presentante: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.presentante } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>     

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de presentación: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.fechaPresentacion ? moment( exhortoRecibido.fechaPresentacion ).format( 'DD-MM-YYYY' ) : '' } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>   

                                {
                                    exhortoRecibido.objetoExhorto
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <List disablePadding>
                                
                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Objeto del exhorto: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.objetoExhorto } </Typography> }
                                                    />

                                                </ListItem>

                                            </List>
                                        
                                        </Grid> 
                                }                

                                {
                                    exhortoRecibido.claseExhorto
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <List disablePadding>
                                
                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Clase del exhorto: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.claseExhorto } </Typography> }
                                                    />

                                                </ListItem>

                                            </List>
                                        
                                        </Grid> 
                                }       

                                {
                                    exhortoRecibido.autoridadExhortoRecibido
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <List disablePadding>
                                
                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhortoRecibido } </Typography> }
                                                    />

                                                </ListItem>

                                            </List>
                                        
                                        </Grid> 
                                }                                 
     
                                <Grid size={{ md: 12, xs: 12 }}>

                                    <List disablePadding>
                        
                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Sintesís: </Typography> }
                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.sintesis } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                                 
                                </Grid>       

                                <Grid size={{ md: 12, xs: 12 }}>

                                   <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                        
                                        <Table>

                                            <TableHead sx={{ ...TableTheadStyle }}>

                                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '50%', fontWeight: 'bold' }}>Nombre</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Tipo de parte</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>¿Es persona moral?</TableCell>
                                        
                                                </TableRow>

                                            </TableHead>

                                            <TableBody>

                                            {
                                                (   rowsPerPage > 0
                                                    ? partes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : partes
                                                ).map( ( row, index ) => (

                                                    <TableRow key={ index } >
                                                        <TableCell> { row.nombre } { row.apellidoPaterno } { row.apellidoMaterno } </TableCell>
                                                        <TableCell> { row.tipo } </TableCell>
                                                        <TableCell sx={{ textAlign: 'center' }}> { row.personaMoral === 1 ? 'Si' : 'No' } </TableCell>
                                                    </TableRow>

                                                ))
                                            }

                                            {
                                                ( partes.length === 0 && exhortoEncontrado ) 
                                                &&                                                
                                                    <TableRow>
                                                       <TableCell
                                                            colSpan={7}
                                                            align="center"                            
                                                        >
                                                            <Typography variant="caption" color='secondary'> No se encontraron partes </Typography>
                                                        </TableCell>
                                                    </TableRow>                                                
                                            }

                                            </TableBody>

                                            <TableFooter>
                                               
                                                <TableRow>

                                                    <TablePagination
                                                        rowsPerPageOptions={[ ]}
                                                        colSpan={3}
                                                        count={partes.length}                                        
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}                                                                                
                                                        onPageChange={ handleChangePage }
                                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                                        ActionsComponent={ TablePaginationActions }
                                                        labelDisplayedRows={
                                                            ({ from, to, count }) => {
                                                            return '' + from + '-' + to + ' de ' + count
                                                            }
                                                        }
                                                    />

                                                </TableRow>                                       

                                            </TableFooter>

                                        </Table>

                                    </TableContainer>  
                                 
                                </Grid>               

                            </Grid>      

                            {
                                ( exhortoEncontrado && !exhortoRecibido.encontrado )
                                &&
                                    <Grid container spacing={3} mt={3}>  
                                
                                        <Grid size={{ md: 12, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Tipo de juicio</InputLabel>
                                            
                                                <Select                                        
                                                    label="Tipo de juicio"
                                                    value={tipoJuicio}
                                                    onChange={ (e) => setTipoJuicio( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        tipoJuicioArray.map( ({ idTipoJuicio, descripcion }) => (
                                                            <MenuItem key={idTipoJuicio} value={idTipoJuicio}>{ descripcion }</MenuItem>   
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>  
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Etapa</InputLabel>
                                            
                                                <Select                                        
                                                    label="Etapa"
                                                    value={etapa}
                                                    onChange={ (e) => setEtapa( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        etapaArray
                                                        .filter( (e) => e.idEtapa === 3 || e.idEtapa === 16 || e.idEtapa === 18 )
                                                        .map( ({ idEtapa, descripcion }) => (
                                                            <MenuItem key={idEtapa} value={idEtapa}>{ descripcion }</MenuItem>   
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>                 
                                    
                                        <Grid size={{ md: 6, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Sub etapa</InputLabel>
                                            
                                                <Select                                        
                                                    label="Sub etapa"
                                                    value={subEtapa}
                                                    onChange={ (e) => setSubEtapa( e.target.value ) }
                                                    disabled={ etapa === 0 || subEtapaArray.length === 0 }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        etapa === 3
                                                        ?
                                                            subEtapaArray
                                                            .filter( (e) => e.idSubEtapa === 2 || e.idSubEtapa === 3 )
                                                            .map( ({ idSubEtapa, descripcion }) => (
                                                                <MenuItem key={idSubEtapa} value={idSubEtapa}>{ descripcion }</MenuItem>   
                                                            ))
                                                        :
                                                            subEtapaArray
                                                            .map( ({ idSubEtapa, descripcion }) => (
                                                                <MenuItem key={idSubEtapa} value={idSubEtapa}>{ descripcion }</MenuItem>   
                                                            ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>       

                                        {
                                            ( subEtapa === 36 )
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>     

                                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es"> 

                                                        <DatePicker                                        
                                                            label="Fecha devolución"       
                                                            sx={{ width: '100%' }}  
                                                            value={ moment( fechaDevolucion ) }
                                                            maxDate={ moment( new Date() ) }
                                                            onChange={ (e) => setFechaDevolucion( moment( e ).format( 'YYYY-MM-DD' ) ) }
                                                        />        

                                                    </LocalizationProvider>      

                                                </Grid> 
                                        }    

                                        <Grid size={{ md: 12, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Autoridad del exhorto</InputLabel>
                                            
                                                <Select                                        
                                                    label="Autoridad del exhorto"
                                                    value={ autoridadExhortoRecibido }
                                                    onChange={ (e) => setAutoridadExhortoRecibido( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        autoridadExhortoRecibidoArray.map( ({ idAutoridadExhortoRecibido, descripcion }) => (
                                                            <MenuItem key={idAutoridadExhortoRecibido} value={idAutoridadExhortoRecibido}>{ descripcion }</MenuItem>   
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>            

                                        <Grid size={{ md: 6, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Objeto del exhorto</InputLabel>
                                            
                                                <Select                                        
                                                    label="Objeto del exhorto"
                                                    value={ objetoExhorto }
                                                    onChange={ (e) => setObjetoExhorto( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        objetoExhortoArray.map( ({ idObjetoExhorto, descripcion }) => (
                                                            <MenuItem key={idObjetoExhorto} value={idObjetoExhorto}>{ descripcion }</MenuItem>   
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>   

                                        <Grid size={{ md: 6, xs: 12 }}>      

                                            <FormControl fullWidth>
                                                <InputLabel>Clase del exhorto</InputLabel>
                                            
                                                <Select                                        
                                                    label="Clase del exhorto"
                                                    value={ claseExhorto }
                                                    onChange={ (e) => setClaseExhorto( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                                    {
                                                        claseExhortoArray.map( ({ idClaseExhorto, descripcion }) => (
                                                            <MenuItem key={idClaseExhorto} value={idClaseExhorto}>{ descripcion }</MenuItem>   
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>   
                                      
                                        <Grid size={{ md: 12, xs: 12 }} sx={{ textAlign: 'center' }} mt={3}> 
                                                        
                                            <Button
                                                variant="contained" 
                                                loading={ loadingGuardar }
                                                onClick={ handleGuardar }
                                                disabled={ 
                                                    tipoJuicio === 0 ||
                                                    etapa === 0 ||
                                                    ( etapa === 0 && subEtapa === 0 && subEtapaArray.length !== 0 ) ||
                                                    autoridadExhortoRecibido === 0 ||
                                                    claseExhorto === 0 ||
                                                    objetoExhorto === 0
                                                }
                                            > 
                                                Guardar Exhorto
                                            </Button>

                                        </Grid>  

                                    </Grid>                                    
                            }

                        </CardContent>    

                    </Card>

                </Grid>

            </Grid> 

        </Layout>
    )
}
